export const FbPixelAnalyticsEvents = {
    // registration events //
    registration_init: 'registration_init',
    registration_phone_provided: 'registration_phone_provided',
    registration_code_provided: 'registration_code_provided',
    // business structure events //
    bs_modal_welcome_app_link_click: 'bs_modal_welcome_app_link_click',
    bs_modal_welcome_app_btn_click: 'bs_modal_welcome_app_btn_click',
};
  